
<template>
    <div>
        <template>
            <tabs fill class="flex-column flex-md-row">
                <card shadow>
                    <tab-pane 
                        title="Medical Applications"
                        @tab-activated="triggerMedicalApplications"
                    >
                        <span slot="title">
                            <i class="ni ni-books"></i>
                            Medical Applications
                        </span>
                        <!-- import Pending Applications template here -->
                        <MedicalRejectedApplications 
                            :type="'medical'"
                            :status="status"
                            ref="callMedicalApplications"
                        />
                    </tab-pane>

                    <tab-pane 
                        title="Dental Applications"
                        @tab-activated="triggerDentalApplications"
                    >
                        <span slot="title">
                            <i class="ni ni-badge"></i>
                            Dental Applications
                        </span>
                        <!-- import Rejected Applications template here -->
                        <!-- <DentalRejectedApplications /> -->
                        <MedicalRejectedApplications 
                            :type="'dental'"
                            :status="status"
                            ref="callDentalApplications"
                        />
                    </tab-pane>
                </card>
            </tabs>
        </template>
    </div>
</template>
<script>
    import MedicalRejectedApplications from './RejectedApplications/MedicalRejectedApplications';
//   import DentalRejectedApplications from './RejectedApplications/DentalRejectedApplications';

    export default {
        name: 'RejectedApplications',
        props: ['status'],
        components: {
            MedicalRejectedApplications,
            // DentalRejectedApplications
        },
        methods: {
            triggerMedicalApplications() {
                if (this.$refs.callMedicalApplications && this.$refs.callMedicalApplications.loadAplications) {
                    this.$refs.callMedicalApplications.loadAplications();
                }
            },
            triggerDentalApplications() {
                if (this.$refs.callDentalApplications && this.$refs.callDentalApplications.loadAplications) {
                    this.$refs.callDentalApplications.loadAplications();
                }
            }
        }
    };
</script>
<style></style>
